import React, { useState, useEffect } from "react";
import {
  Card,
  CardContent,
  Button,
  Tabs,
  Tab,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import axios from "axios";
import DatatableComponent from "../../helpers/DatatableComponent";
import { useHistory } from "react-router";
import StaffPositionComponent from "../../components/Settings/StaffPosition";
import TabBoxComponent from "../../components/UI/TabBox";
import StructureHierachy from "../../helpers/StructureHierachy";
import { mapStateToProps } from "store/helpers/mapState";
import { mapDispatchToProps } from "store/helpers/mapDispatch";
import { connect } from "react-redux";
import CichiinEmployeeComponent from "./CichiinEmployeeComponent";

function IFStructure({ structures, systemSettings, wholeStructure }) {
  const [selectedTab, setSelectedTab] = useState(0);
  const [departmentTabValue, setDepartmentTabValue] = useState(0); // New state for department tabs
  const [errorMessage, setErrorMessage] = useState("");
  // const [open, setOpen] = useState(0);
  const [value, setValue] = useState({});
  const [count, setCount] = useState(0);
  const [tabValue, setTabValue] = useState(0);
  const [list, setList] = React.useState([]);
  const history = useHistory();
  const [info, setInfo] = useState({ status: tabValue === 0 ? "active" : "quit" });
  const [selectedStructure, setSelectedStructure] = React.useState();

  const mainBackground = systemSettings?.mainBackground;

  useEffect(() => {
    // console.log("Selected Structure:", wholeStructure);
  }, [wholeStructure]);

  const [deleteConfirmation, setDeleteConfirmation] = useState({
    open: false,
    id: null,
    type: "",
  });

  // const confirmDelete = (id, type) => {
  //   setDeleteConfirmation({ open: true, id, type });
  // };

  const handleDeleteConfirmed = async () => {
    const { id, type } = deleteConfirmation;
    try {
      let response;
      if (type === "institution") {
        response = await axios.delete(`/api/institutions/${id}`);
      } else if (type === "department") {
        response = await axios.delete(`/api/departments/${id}`);
      } else if (type === "office") {
        response = await axios.delete(`/api/offices/${id}`);
      } else if (type === "division") {
        response = await axios.delete(`/api/divisions/${id}`);
      }

      if (response.status === 200) {
        setCount((v) => v + 1);
        setErrorMessage("Deleted successfully.");
      } else {
        setErrorMessage("Failed to delete. Please try again.");
      }
    } catch (error) {
      setErrorMessage("Failed to delete. Please try again.");
    } finally {
      setDeleteConfirmation({ open: false, id: null, type: "" });
    }
  };

  const handleDeleteCancelled = () => {
    setDeleteConfirmation({ open: false, id: null, type: "" });
  };

  const handleTabChange = (event, newValue) => {
    setSelectedTab(newValue);
    if (newValue === 1) {
      history.push("/admin/resources", { state: { tab: 1 } });
    }
  };

  // New handler for department tabs
  const handleDepartmentTabChange = (event, newValue) => {
    setDepartmentTabValue(newValue);
  };


  useEffect(() => { }, [value.PlaceOfBirth?.cell]);

  useEffect(() => { }, [value.PlaceOfBirth?.district]);

  useEffect(() => {
    setInfo({ ...info, structureId: selectedStructure?.id })
  }, [selectedStructure]);


  const columns = [
    {
      name: "names",
      label: "Names"
    },
    {
      name: "phone",
      label: "Phone No"
    },
    {
      name: "positionName",
      label: "Position",
    },
    {
      name: "lineManager",
      label: "Line Manager",
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value) => {
          return value ? "Yes" : "No";
        },
      },
    },
  ];


  return (
    <div className="w-full mb-12 px-4">
      <Card className="flex flex-col w-full">
        <CardContent>
          <TabBoxComponent
            selectedValue={selectedTab}
            handleTabChange={handleTabChange}
            tabList={[
              {
                label: "Structure",
                tabValue: 0,
                permissionCode: "menu.structure",
              },
              {
                label: "Employees",
                tabValue: 1,
                permissionCode: "submenu.employee",
              },
              {
                label: "Positions",
                tabValue: 2,
                permissionCode: "submenu.position",
              },

            ]}
          />
          <hr style={{ border: "0.5px solid #ccc", margin: "10px 0" }} />{" "}
          {selectedTab === 0 && (
            <div>

              <div className="flex">
                <Card
                  style={{
                    flex: 0.4,
                    marginRight: "10px",
                    borderRadius: "5px",
                    overflowY: "auto",
                    maxHeight: "600px",
                  }}
                >
                  <CardContent>
                    <h2
                      style={{
                        backgroundColor: mainBackground,
                        color: "white",
                        padding: "8px",
                      }}
                    >
                      Departments and its Units
                    </h2>
                    <Tabs
                      value={departmentTabValue}
                      onChange={handleDepartmentTabChange}
                      TabIndicatorProps={{
                        style: {
                          borderRadius: "10px",
                          backgroundColor: mainBackground,
                        },
                      }}
                    >
                      <Tab
                        label="hierarchy"
                        style={{
                          marginLeft: "10px",
                          marginBottom: "10px",
                          marginTop: "10px",
                          borderRadius: "10px",
                          backgroundColor:
                            departmentTabValue === 0
                              ? mainBackground
                              : "transparent",
                          color: departmentTabValue === 0 ? "white" : "black",
                        }}
                      />
                    </Tabs>

                    <StructureHierachy
                      structures={structures}
                      wholeStructure={wholeStructure}
                      setSelectedStructure={setSelectedStructure}
                    />
                  </CardContent>
                </Card>
                <Card
                  // className="w-1/2"
                  style={{
                    flex: 0.6,
                    borderRadius: "5px",
                    borderWidth: "1px",
                    overflowY: "auto",
                    maxHeight: "600px",
                  }}
                >
                  <DatatableComponent
                    hideToolbar={true}
                    onRowClick={(data, { rowIndex }) => {
                      history.push(`/admin/profile/${list[rowIndex].id}`);
                    }}
                    processData={(data) => {
                      setList(data.data);
                      return data;
                    }}
                    elevation={0}
                    columns={columns}
                    url={`/api/resource/list?count=${count}&info=${JSON.stringify(info)}`}
                    title={
                      <div className="flex flex-col md:flex-row gap-2 ">
                        <div className="md:w-full w-1/6 mb-2 xl:mb-0 "></div>
                      </div>
                    }
                  />
                </Card>
              </div>
            </div>
          )}
          {selectedTab === 2 && <StaffPositionComponent />}

          {selectedTab === 1 && <CichiinEmployeeComponent />}
        </CardContent>
      </Card>

      <Dialog open={deleteConfirmation.open} onClose={handleDeleteCancelled}>
        <DialogTitle>Confirm Deletion</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Are you sure you want to delete this {deleteConfirmation.type}?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleDeleteCancelled} color="primary">
            Cancel
          </Button>
          <Button onClick={handleDeleteConfirmed} color="secondary">
            Delete
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}

// export default IFStructure;
export default connect(mapStateToProps, mapDispatchToProps)(IFStructure);

